import * as React from "react";

const VideoFilmComponent = (props) => (
  <svg width={16} height={19} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.2.4h-3.6v1.2H4.4V.4H.8v18h3.6v-1.2h7.2v1.2h3.6V.4Zm-12 1.2v1.2H2V1.6h1.2Zm10.8 0v1.2h-1.2V1.6H14Zm-2.4 1.2v6H4.4v-6h7.2ZM3.2 4v1.2H2V4h1.2ZM14 4v1.2h-1.2V4H14ZM3.2 6.4v1.2H2V6.4h1.2Zm10.8 0v1.2h-1.2V6.4H14ZM3.2 8.8V10H2V8.8h1.2Zm10.8 0V10h-1.2V8.8H14ZM11.6 10v6H4.4v-6h7.2Zm-8.4 1.2v1.2H2v-1.2h1.2Zm10.8 0v1.2h-1.2v-1.2H14ZM3.2 13.6v1.2H2v-1.2h1.2Zm10.8 0v1.2h-1.2v-1.2H14ZM3.2 16v1.2H2V16h1.2ZM14 16v1.2h-1.2V16H14Z"
      fill="#3E435F"
    />
  </svg>
);

export default VideoFilmComponent;
